import store from '../store'
//import i18n from '../i18n'

const AuthLayout = () => import('@/pages/Dashboard/Pages/AuthLayout.vue')
const Login = () => import('@/pages/Dashboard/Pages/Login.vue')

const DashboardLayout = () =>
  import('@/pages/Dashboard/Layout/DashboardLayout.vue')
// Dashboard pages

const Home = () => import('@/pages/Dashboard/Dashboard.vue')
const Map = () => import('@/pages/Dashboard/Maps/Country')
const Planning = () => import('@/pages/Dashboard/Planning')
const Plans = () => import('@/pages/Dashboard/Planning/plans')
const PlanParams = () => import('@/pages/Dashboard/Planning/planParams')
const Reports = () => import('@/pages/Dashboard/Reports')
const Translate = () => import('@/pages/Dashboard/Translate')
const TranslateProfileForm = () =>
  import('@/pages/Dashboard/Translate/translateProfileForm.vue')

const userLogout = async (to, from, next) => {
  await store.dispatch('LOGOUT')
  next('/login')
}

const checkLocales = async (to, from, next) => {
  if (!store.getters.localesListLoaded) {
    await store.dispatch('LOAD_LOCALES_LIST')
  }
  next()
}

const checkLoginLangMessage = async (to, from, next) => {
  const actLang = store.getters.locale_active
  await store.dispatch('LOAD_LOGIN_TRANSLATE', actLang)
  next()
}

const checkAuthAndAccess = async (to, from, next) => {
  if (store.getters.hasToken) {
    store.commit('SET_HEADER_AUTH')
    try {
      if (!store.getters.profileLoaded) {
        await store.dispatch('GET_MY_PROFILE')
      }

      if (!store.getters.appOptionsLoaded) {
        await store.dispatch('LOAD_APP_OPTIONS')
      }

      //const locales = Object.keys(i18n.messages)
      const actLang = store.getters.locale_active

      if (!store.getters.isUiTranslateLoaded) {
        await store.dispatch('LOAD_UI_TRANSLATE', actLang)
      }
      next()
    } catch {
      next('/login')
    }
  } else {
    store.commit('SET_REDIRECT_AFTER_LOGIN', to.fullPath)
    next('/login')
  }
}

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  beforeEnter: checkLocales,
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: checkLoginLangMessage
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: userLogout
    }
  ]
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },

  {
    path: '/',
    component: DashboardLayout,
    beforeEnter: checkLocales,
    children: [
      {
        path: 'home',
        name: 'Dashboard',
        components: {default: Home},
        meta: {hideFooter: true},
        beforeEnter: checkAuthAndAccess
      },
      {
        path: 'translate',
        name: 'Translate',
        components: {default: Translate},
        meta: {hideFooter: true},
        beforeEnter: checkAuthAndAccess
      },
      {
        path: 'translate_add',
        name: 'Translate_add',
        component: TranslateProfileForm,
        meta: {hideFooter: true},
        beforeEnter: checkAuthAndAccess,
        props: {oper: 'add'}
      },
      {
        path: 'map',
        name: 'Map',
        components: {default: Map},
        meta: {hideFooter: true, hideScroll: true},
        beforeEnter: checkAuthAndAccess
      },
      {path: '/planning', redirect: '/planning/data/def'},
      {
        path: 'planning/data/:plan_id',
        name: 'Planning-data',
        components: {default: Planning},
        meta: {hideFooter: true, hideScroll: true},
        props: {default: true},
        beforeEnter: checkAuthAndAccess
      },
      {
        path: 'plans/',
        name: 'Plan-list',
        components: {default: Plans},
        meta: {hideFooter: true, hideScroll: true},
        props: {default: true},
        beforeEnter: checkAuthAndAccess
      },
      {
        path: 'plans/params/:plan_id',
        name: 'Plan-params',
        components: {default: PlanParams},
        meta: {hideFooter: true, hideScroll: true},
        beforeEnter: checkAuthAndAccess,
        props: {default: true}
      },
      {path: '/reports', redirect: '/reports/list'},
      {
        path: 'reports/:report_type',
        name: 'Reports',
        components: {default: Reports},
        meta: {hideFooter: true, hideScroll: true},
        beforeEnter: checkAuthAndAccess,
        props: {default: true}
      }
      // {
      //   path: 'reports',
      //   name: 'Reports',
      //   components: {default: Reports},
      //   meta: {hideFooter: true, hideScroll: true},
      //   beforeEnter: checkAuthAndAccess,
      // }
    ]
  },
  authPages,
  {
    path: '*',
    redirect: '/home'
  }
]

export default routes
